import { render, staticRenderFns } from "./SelectExpress.vue?vue&type=template&id=38120afc&scoped=true"
import script from "./SelectExpress.vue?vue&type=script&lang=js"
export * from "./SelectExpress.vue?vue&type=script&lang=js"
import style0 from "./SelectExpress.vue?vue&type=style&index=0&id=38120afc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38120afc",
  null
  
)

export default component.exports